import { render, staticRenderFns } from "./Legends.vue?vue&type=template&id=358b96e6&scoped=true"
import script from "./Legends.vue?vue&type=script&lang=js"
export * from "./Legends.vue?vue&type=script&lang=js"
import style0 from "./Legends.vue?vue&type=style&index=0&id=358b96e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358b96e6",
  null
  
)

export default component.exports